/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, OnInit, OnChanges, ViewChild} from '@angular/core';
import { ServerObjectService } from '../../services/server-object.service';
import {ServiceService} from "../../services/service.service";
import {NgxSpinnerService} from "ngx-spinner";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from '../simple-success-error-dialog-box/simple-success-error-dialog-box.component';

declare var $: any;

@Component({
  selector: 'app-settings-password',
  templateUrl: './settings.password.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsPasswordComponent implements OnInit, OnChanges {

    /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  @Input() passwordPolicy;
  serverObjectInstance = null;
  min_upper: number;
  min_lower: number;
  min_length: number;
  min_alpha: number;
  min_numeric: number;
  min_special: number;
  duplicates: number;
  expire: number;
  allow_whitespace: boolean;

  constructor(private services: ServiceService, private serverObjectService: ServerObjectService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

  }

  ngOnChanges(): void {
    if (this.passwordPolicy) {
      // Found the email service
      console.log("password_policy id is " + this.passwordPolicy.id);

      this.serverObjectService.getServerObjectInstanceById(this.passwordPolicy.id).then(response => {
          this.serverObjectInstance = response;
          this.setPasswordSettings();
        },
        error => {
          this.handleError(error);
        });
    }
  }

  private setPasswordSettings(): void {
    if (this.serverObjectInstance.data && this.serverObjectInstance.data.length > 0) {
      for (const data of this.serverObjectInstance.data) {
        switch (data.property.property) {
          case "min_length":
          case "min_upper":
          case "min_lower":
          case "min_alpha":
          case "min_numeric":
          case "min_special" :
          case "expire" :
          case "duplicates":
            this[data.property.property] = data.value;
            break;
          case "allow_whitespace":
            this[data.property.property] = (data.value == "true");
            break;
        }
      }
    }
  }

  public updateSettingsPassword(): void {
    this.spinner.show();

    if (this.serverObjectInstance.data && this.serverObjectInstance.data.length > 0) {
      for (const data of this.serverObjectInstance.data) {
        switch (data.property.property) {
          case "min_length":
          case "min_upper":
          case "min_lower":
          case "min_alpha":
          case "min_numeric":
          case "min_special" :
          case "expire" :
          case "duplicates":
            data.value = this[data.property.property];
            break;
          case "allow_whitespace":
            data.value = (this[data.property.property]) ? "true" : "false";
            break;
        }
        data.object_value = this[data.property.property];
      }
    }

    this.serverObjectService.updateServerObjectInstance(this.serverObjectInstance)
      .then(
        response => {
          this.spinner.hide();
          console.log("update UserLockout Instance successful");
        },
        error => {
          this.spinner.hide();
          this.handleError(error);
        }
      );
  }

  allowWhitespaceClicked(): void {
    this.allow_whitespace = $("#allow_whitespace")[0].checked;
  }

  handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, response.text().toString());
    }
  }

}
